import { Evaluation } from '@/models/Evaluation';
import { Lesson } from '@/models/Lesson';
import { LinkMetadata } from '@/models/LinkMetadata';
import { AxiosError } from 'axios';

export enum LessonTypes {
    GET_LESSON_REQUEST = '@lesson/GET_LESSON_REQUEST',
    GET_LESSON_SUCCESS = '@lesson/GET_LESSON_SUCCESS',
    GET_LESSON_PATH_SUCCESS = '@lesson/GET_LESSON_PATH_SUCCESS',
    GET_LESSON_FAILURE = '@lesson/GET_LESSON_FAILURE',
    GET_LESSON_CLEAR = '@lesson/GET_LESSON_CLEAR',
    GET_LMS_LESSONS_REQUEST = '@lesson/GET_LMS_LESSONS_REQUEST',
    GET_LESSONS_REQUEST = '@lesson/GET_LESSONS_REQUEST',
    GET_LESSONS_SUCCESS = '@lesson/GET_LESSONS_SUCCESS',
    GET_LESSONS_FAILURE = '@lesson/GET_LESSONS_FAILURE',
    SET_LESSON_EXTERNAL_LINK_METADATA_REQUEST = '@lesson/SET_LESSON_EXTERNAL_LINK_METADATA_REQUEST',
    SET_LESSON_EXTERNAL_LINK_METADATA_SUCCESS = '@lesson/SET_LESSON_EXTERNAL_LINK_METADATA_SUCCESS',
    SET_LESSON_EXTERNAL_LINK_METADATA_FAILURE = '@lesson/SET_LESSON_EXTERNAL_LINK_METADATA_FAILURE',
    POST_LESSON_REQUEST = '@lesson/POST_LESSON_REQUEST',
    POST_LESSON_SUCCESS = '@lesson/POST_LESSON_SUCCESS',
    POST_LESSON_FAILURE = '@lesson/POST_LESSON_FAILURE',
    POST_LESSON_CLEAR = '@lesson/POST_LESSON_CLEAR',
    POST_EVALUATION_CLEAR = '@lesson/POST_EVALUATION_CLEAR',
    POST_EVALUATION_REQUEST = '@lesson/POST_EVALUATION_REQUEST',
    POST_EVALUATION_SUCCESS = '@lesson/POST_EVALUATION_SUCCESS',
    POST_EVALUATION_FAILURE = '@lesson/POST_EVALUATION_FAILURE',
    PUT_LESSON_REQUEST = '@lesson/PUT_LESSON_REQUEST',
    PUT_LESSON_REORDER_REQUEST = '@lesson/PUT_LESSON_REORDER_REQUEST',
    PUT_EVALUATION_LESSON_REQUEST = '@lesson/PUT_EVALUATION_LESSON_REQUEST',
    PUT_LESSON_SUCCESS = '@lesson/PUT_LESSON_SUCCESS',
    PUT_LESSON_FAILURE = '@lesson/PUT_LESSON_FAILURE',
    PUT_LESSON_CLEAR = '@lesson/PUT_LESSON_CLEAR',
    DELETE_LESSON_REQUEST = '@lessonDELETE_LESSON_REQUEST',
    DELETE_LESSON_SUCCESS = '@lessonDELETE_LESSON_SUCCESS',
    DELETE_LESSON_FAILURE = '@lessonDELETE_LESSON_FAILURE',
    DELETE_LESSON_CLEAR = '@lesson/DELETE_LESSON_CLEAR',
    START_LESSON_REQUEST = '@lesson/START_LESSON_REQUEST',
    START_LESSON_SUCCESS = '@lesson/START_LESSON_SUCCESS',
    START_LESSON_FAILURE = '@lesson/START_LESSON_FAILURE',
    FINISH_LESSON_REQUEST = '@lesson/FINISH_LESSON_REQUEST',
    FINISH_LESSON_SUCCESS = '@lesson/FINISH_LESSON_SUCCESS',
    FINISH_LESSON_FAILURE = '@lesson/FINISH_LESSON_FAILURE',
    SET_CURRENT_LESSON = '@lesson/SET_CURRENT_LESSON',
    SET_CURRENT_LESSON_FOR_EDITION = '@lesson/SET_CURRENT_LESSON_FOR_EDITION',
    DECREASE_LESSON_QUESTIONS_AMOUNT = '@lesson/DECREASE_LESSON_QUESTIONS_AMOUNT',
    INCREASE_LESSON_QUESTIONS_AMOUNT = '@lesson/INCREASE_LESSON_QUESTIONS_AMOUNT',
    CLEAR_START_SUCCESS = '@lesson/START_CLEAR_SUCCESS',
}

export interface Lessons {
    lessons: Lesson[];
}

export interface LessonsState {
    data: Lessons;
    currentData: Lesson | undefined;
    evaluation: Evaluation | undefined;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
    mediaUrl: string | undefined;
    externalUrlMetadata: LinkMetadata | undefined;
    successOnPostEvaluation: boolean;
}
